/* eslint-disable max-lines */
import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { MFA_FLOW_FIRST_SCREEN } from '../constants/login-constant';
import { loginAndGetDashboardResponse } from '../models/login-authentication-screen.interface';
import { PingLoginAdapterExtendedSupportService } from './ping-login-adapter-extended-support.service';

@Injectable({
  providedIn: 'root'
})
export class PingLoginAdapterSupportService extends PingLoginAdapterExtendedSupportService {
  refreshUrl!: string | undefined;
  redirectRefreshUrlCheck = false;
  queryParamRefreshUrl!: string;
  processRedirectionLogicHelper(
    cookieNameForPicker: string | number | boolean,
    corpCookie: string | null,
    isHipmunk: string | boolean | null,
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig,
    standalonePage = false,
    tokenResponse?: string
  ) {
    cookieNameForPicker =
      corpCookie && !isHipmunk ? 'false-false' : 'true-false';
    this.loginUtilHelperService.setAccountTypeCookie(
      cookieNameForPicker,
      authenticationConfig
    );
    this.processRedirectionLogicHelperLogic(
      response,
      standalonePage,
      authenticationConfig,
      tokenResponse
    );
  }

  processRedirectionLogicHelperLogic(
    response: loginAndGetDashboardResponse,
    standalonePage: boolean,
    authenticationConfig?: OauthAEMConfig,
    tokenResponse?: string
  ) {
    if (
      this.returnToOriginalUrl(response, authenticationConfig) &&
      !standalonePage
    ) {
      return window.location.reload();
    } else {
      return this.redirectToRefreshUrl(
        standalonePage,
        response,
        authenticationConfig,
        tokenResponse
      );
    }
  }

  returnToOriginalUrlForDdcfbUserHelper(
    response: loginAndGetDashboardResponse,
    loginPickerRoute: string | undefined,
    redirectUrlModified: string,
    authenticationConfig?: OauthAEMConfig,
    tokenResponse?: string
  ) {
    if (
      this.returnToOriginalUrl(response, authenticationConfig) &&
      response?.queryParams
    ) {
      const queryParamsModified = encodeURIComponent(response.queryParams);
      const routePath = `${loginPickerRoute}?fromModal=true&queryParams=${queryParamsModified}&bauRefreshURL=${redirectUrlModified}`;
      this.routeBasedOnCondition(routePath);
    } else {
      const routePath = `${loginPickerRoute}?fromModal=true&refreshURL=${redirectUrlModified}`;
      this.redirectToMfaForDdcfbUser(
        routePath,
        redirectUrlModified,
        authenticationConfig,
        response,
        tokenResponse
      );
    }
  }

  redirectToMfaForDdcfbUser(
    routePath: string,
    redirectUrlModified: string,
    authenticationConfig?: OauthAEMConfig,
    response?: loginAndGetDashboardResponse,
    tokenResponse?: string
  ) {
    this.mfaUtilService.timeStampExpiry(authenticationConfig);
    if (
      this.mfaUtilService.validateMFARedirection(
        authenticationConfig,
        response
      ) &&
      this.coreUtilService.redirectToMfa(response, tokenResponse)
    ) {
      window.location.assign(
        `${MFA_FLOW_FIRST_SCREEN}?fromModal=true&refreshURL=${redirectUrlModified}`
      );
    } else {
      this.routeBasedOnCondition(routePath);
    }
  }

  returnToOriginalUrlForDdcfbUser(
    redirectUrlModified: string,
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig,
    standalonePage = false,
    tokenResponse?: string
  ) {
    const loginPickerRoute = standalonePage
      ? authenticationConfig?.LOGIN_PICKER_STANDALONE
      : authenticationConfig?.LOGIN_PICKER;

    if (standalonePage) {
      if (this.returnToOriginalUrl(response, authenticationConfig)) {
        const queryParamsModified = window.location.search;
        const routePath = `${loginPickerRoute}?fromModal=true&${queryParamsModified.replace(
          '?',
          ''
        )}`;
        this.routeBasedOnCondition(routePath);
      } else {
        const routePath = `${loginPickerRoute}?fromModal=true&refreshURL=${redirectUrlModified}`;
        this.redirectToMfaForDdcfbUser(
          routePath,
          redirectUrlModified,
          authenticationConfig,
          response,
          tokenResponse
        );
      }
    } else {
      this.returnToOriginalUrlForDdcfbUserHelper(
        response,
        loginPickerRoute,
        redirectUrlModified,
        authenticationConfig,
        tokenResponse
      );
    }
  }

  redirectionLogicForBusinessUser(
    restrictLoginPicker: boolean,
    isHipmunk: string | false | null,
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig,
    standalonePage = false,
    fromAdmin = false,
    tokenResponse?: string
  ) {
    if (restrictLoginPicker) {
      if (!isHipmunk) {
        if (!fromAdmin) {
          this.loginUtilHelperService.setCookieToRestrictToPersonal(
            authenticationConfig
          );
          this.nuTravelSkyBonusUtilService.redirectUserToRefreshUrl(
            this.fromApplication,
            this.redirectUrl,
            response.refreshURL,
            authenticationConfig
          );
        } else {
          this.nuTravelSkyBonusUtilService.getQueryParamsFromAdmin();
          window.location.assign(window.location.origin);
        }
      }
    } else {
      this.redirectAfterRefreshUrlSet(
        standalonePage,
        response,
        authenticationConfig,
        tokenResponse
      );
    }
  }

  redirectAfterRefreshUrlSet(
    standalonePage: boolean,
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig,
    tokenResponse?: string
  ) {
    let redirectUrlModified = '';
    if (standalonePage) {
      this.checkRedirectBack(response);
    } else {
      this.updateRefreshURL(response.refreshURL);
    }
    if (this.refreshUrl) {
      this.checkForCancelConfirmationUrl();
      redirectUrlModified = encodeURIComponent(this.refreshUrl);
    }
    this.returnToOriginalUrlForDdcfbUser(
      redirectUrlModified,
      response,
      authenticationConfig,
      standalonePage,
      tokenResponse
    );
  }
}
